<template>
    <div class="container" >
        <div class="container-head">{{sonMsg.helpActicleTypeNameCn}}</div>
        <div class="container-box">
            <!-- <div class="container-box-item"  v-for="(item,index) in sonMsg.content" :key="index"> -->
            <div class="container-box-item"  v-for="(item,index) in sonMsgData" :key="index">
                <div style="margin-bottom:5px;">
                    <span  v-if="item.tag == '热门'" style="margin-right:10px;"><img src="../assets/img/hot.png" alt=""></span> 
               
                    <span class="container-box-item-content" @click="goDetailInfo(item,index)">{{item.nameCn}}</span>     
                    <span class="container-box-item-time">更新时间：{{item.addDate}}</span>
                </div>
               
            </div>
            <div v-if="sonMsg.content.length == 0" style="margin-top:200px;text-align:center;">
                <span >暂无数据</span>
            </div>
            <div class="block" v-if="sonMsg.content.length != 0">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="totalNum">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
// import {getHelpActicleListForPc} from '@/api/api.js'
export default {
    name: 'home',
    props:{
        sonMsg:{}
    },
    data() {
        return {
            sonMsgData:[],
            start:(this.currentPage-1) * this.pageSize,
            end:this.currentPage * this.pageSize,
            currentPage:1,
            pageSize:10,
            totalNum:this.sonMsg.content.length 
        }
    },
    watch:{
        sonMsg:{
            handler(){
                this.currentPage = 1
                this.sonMsgData = this.sonMsg.content.slice((this.currentPage-1) * this.pageSize,this.currentPage * this.pageSize)
                this.totalNum = this.sonMsg.content.length 
            },
            deep:true
        }
    },
    methods:{
        goDetailInfo(item,index){
            
            this.sonMsg.content.forEach((item1,index1) => {
                if(item1.numberCode == item.numberCode){
                     index = index1
                }
            });
            this.$parent.goDetailInfo(item);
            this.$parent.listIdx = index;
        },
        //分页
        handleCurrentChange(val){
            this.currentPage = val
            this.changeData()
            // console.log(val)
        },
        changeData(){
            this.sonMsgData = this.sonMsg.content.slice((this.currentPage-1) * this.pageSize,this.currentPage * this.pageSize)
        }
    },
    mounted() {
        this.changeData()
    }
}
</script>
<style scoped lang="less">
    .container{
        padding:0 20px 20px 20px;
        .container-head{
            font-size: 18px;
            font-weight: 700;
            line-height: 28px;
            margin-bottom: 20px;
            text-align: left;

        }
        .container-box{
            .container-box-item{
                text-align: left;
                font-size: 14px;
                margin: 5px 0;
                overflow: hidden;
                &:not(:last-child){
                    border-bottom: 1px solid #eee;
                }
                
                padding: 14px 0;
                .container-box-item-content{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display:inline-block;
                    width:68%;
                    vertical-align: middle;
                    cursor: pointer;
                    color:#606166;
                    &:hover{
                        color: #4646fd;
                    }
                }
                .container-box-item-time{
                    float: right;
                    margin-left: 20px;
                    font-size: 12px;
                    color: #999;
                }
                
                .hot{
                    display:inline-block;
                    border: 1px solid #FF0000;
                    padding: 4px 10px;
                    border-radius: 4px;
                    color: #FF0000;
                    margin-right: 20px;
                }
            }
        }

    }
    .block{
        margin-top: 14px;
       
    }
  
</style>